  import React from "react"

  export default function ConfirmProceedModal({ show, onOk, onClose }) {
    if (!show) return null

    return (
      <>
        <div style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0,0,0,0.5)",
          zIndex: 999999
        }} />
        <div style={{
          position: "fixed",
          top: "40%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          backgroundColor: "#fff",
          padding: "20px",
          border: "3px solid var(--lumiq-card-bg)",
          borderRadius: "8px",
          width: "80%",
          maxWidth: "600px",
          zIndex: 1000000
        }}>
          <span
            onClick={onClose}
            style={{
              position: "absolute",
              top: "8px",
              right: "12px",
              fontSize: "22px",
              fontWeight: "bold",
              color: "var(--lumiq-card-bg)",
              cursor: "pointer",
              lineHeight: "1"
            }}
          >&times;</span>
          <div style={{ display: "flex", justifyContent: "center", marginBottom: "15px" }}>
            <h4 style={{ textAlign: "center", color: "var(--lumiq-card-bg)", margin: 0 }}>Confirmation</h4>
          </div>
          <p style={{ textAlign: "center", fontSize: "15px" }}>
            Application once finalized at this stage cannot be altered later. In case you wish to change Benefit Illustration / Proposal Form Details then please click on Re-calculate button.
          </p>
          <button
            onClick={onOk}
            style={{
              backgroundColor: "var(--lumiq-tertiary)",
              color: "#fff",
              padding: "8px 16px",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
              display: "block",
              margin: "0 auto"
            }}
          >
            Click To Proceed
          </button>
        </div>
      </>
    )
  }
